import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-ui-wrapper',
    templateUrl: './ui-wrapper.component.html',
    styleUrls: ['./ui-wrapper.component.scss'],
    standalone: false
})
export class UiWrapperComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
